export class CredencialRecusadaError extends Error {
    constructor(mensagem = 'Não foi possível autenticar com os dados informados.') {
        super(mensagem);
        this.name = 'CredencialRecusadaError';
    }
}

export class LoginBloqueadoError extends Error {
    constructor(esperarSegundos) {
        super(`Login bloqueado; tentar de novo em ${esperarSegundos}s.`);
        this.name = 'LoginBloqueadoError';
        this.esperarSegundos = esperarSegundos;
    }
}

/** O tablet não sabe a que turma pertence: falta configuração, não credencial. */
export class TurmaAusenteError extends Error {
    constructor() {
        super('Tablet sem turma configurada.');
        this.name = 'TurmaAusenteError';
    }
}

export function baseHttpDeWs(urlWs) {
    return String(urlWs).replace(/^ws/, 'http').replace(/\/+$/, '');
}

export class AuthClient {
    /**
     * @param {string} baseUrl base HTTP, ex.: "http://localhost:8000"
     * @param {{buscar?: typeof fetch}} [opcoes] `buscar` existe para o teste
     *   injetar; o navegador usa o fetch nativo.
     */
    constructor(baseUrl, { buscar = globalThis.fetch?.bind(globalThis) } = {}) {
        this.baseUrl = String(baseUrl).replace(/\/+$/, '');
        this._buscar = buscar;
    }

    /**
     * `POST /api/v1/auth/login/participante`.
     *
     * @returns {Promise<{token: string, papel: string, turma_id: string,
     *   grupo_id: string, participante_id: string}>}
     */
    async loginParticipante({ turmaId, matricula, codigo, dispositivo }) {
        const resposta = await this._buscar(`${this.baseUrl}/api/v1/auth/login/participante`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ...(turmaId ? { turma_id: turmaId } : {}),
                matricula,
                ...(codigo ? { codigo } : {}),
                ...(dispositivo ? { dispositivo } : {}),
            }),
        });

        return this._lerResposta(resposta);
    }

    /**
     * `POST /api/v1/auth/login/operacao` — conta facilitadora do telão (RN-BF-044).
     *
     * @returns {Promise<{token: string, papel: string, turma_id: string|null,
     *   estacao: string|null}>}
     */
    async loginOperacao({ login, senha, turmaId }) {
        const resposta = await this._buscar(`${this.baseUrl}/api/v1/auth/login/operacao`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ login, senha, ...(turmaId ? { turma_id: turmaId } : {}) }),
        });
        return this._lerResposta(resposta);
    }

    /** Mesmo contrato de falha para os dois logins: 429 bloqueia, o resto recusa. */
    async _lerResposta(resposta) {
        if (resposta.status === 429) {
            const cabecalho = resposta.headers?.get?.('Retry-After');
            throw new LoginBloqueadoError(Number(cabecalho) || 60);
        }

        if (!resposta.ok) {
            const corpo = await resposta.json().catch(() => ({}));
            throw new CredencialRecusadaError(corpo.mensagem);
        }

        return resposta.json();
    }
}
